// PusherEmitter.js
import { connect } from 'react-redux';

import PusherEmitter from '../component/PusherEmitter.jsx';

import {
  PUSHER_APP_ID,
  PUSHER_APP_KEY,
  PUSHER_APP_CLUSTER,
  PUSHER_WSS_HOST,
  PUSHER_WS_HOST,
  PUSHER_WSS_PORT,
  PUSHER_ENABLED_TRANSPORTS,
  PUSHER_STALLED_CHANNEL_CHECK_INTERVAL,
  PUSHER_STALLED_CHANNEL_TRACK_LIMIT,
} from '../RemoteConfigKeys.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import mergeMeData from '../action/mergeMeData.js';
import getOperationData from '../selector/getOperationData.js';
import { updatePusherConnectionData } from '../action/updatePusherData.js';
import updateServiceWorkStatus from '../action/updateServiceWorkStatus.js';
import updatePusherDistinctId from '../action/updatePusherDistinctId.js';
import i18n from '../resource/i18n.js';
import { localeConvertor } from '../resource/i18nCommon.js';
import {
  CONFIG_PRIORITY_PRESENCE_USER,
  CONFIG_PRIORITY_PRESENCE_CLIENT,
} from '../resource/configPriority.js';

const mapStateToProps = state => {
  const userId = getMeData(state, 'id');
  const token = getMeData(state, 'token');
  const refreshToken = getMeData(state, 'refreshToken');
  const language = localeConvertor({
    locale: getOperationData(state, ['config'], 'language') || i18n.language,
    isISO639: true,
  });

  return {
    userId,
    isRemoteConfigMerged: refreshToken
      ? getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_USER)
      : getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_CLIENT),
    isAuthed: Boolean(userId),
    pusherWssHost: getRemoteConfigData(state, PUSHER_WSS_HOST),
    pusherWsHost: getRemoteConfigData(state, PUSHER_WS_HOST),
    pusherWssPort: getRemoteConfigData(state, PUSHER_WSS_PORT),
    pusherEnabledTransports: getRemoteConfigData(
      state,
      PUSHER_ENABLED_TRANSPORTS
    ),
    pusherAppId: getRemoteConfigData(state, PUSHER_APP_ID),
    pusherKey: getRemoteConfigData(state, PUSHER_APP_KEY),
    pusherCluster: getRemoteConfigData(state, PUSHER_APP_CLUSTER),
    clientId: getMeData(state, 'clientId'),
    token,
    country: getMeData(state, 'country'),
    language,
    serviceWorkerStatus: getOperationData(state, ['serviceWorker'], 'status'),
    pusherChannels: getOperationData(state, ['pusher', 'channels']),
    pusherConnectionState: getOperationData(
      state,
      ['pusher', 'connection'],
      'state'
    ),
    pusherStalledChannelCheckInterval: getRemoteConfigData(
      state,
      PUSHER_STALLED_CHANNEL_CHECK_INTERVAL
    ),
    pusherStalledChannelCheckLimit: getRemoteConfigData(
      state,
      PUSHER_STALLED_CHANNEL_TRACK_LIMIT
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    mergeMeData: ({ field, value }) => dispatch(mergeMeData({ field, value })),
    dispatch,
    updateServiceWorkStatus: data => dispatch(updateServiceWorkStatus(data)),
    updatePusherConnectionData: data =>
      dispatch(updatePusherConnectionData(data)),
    updatePusherDistinctId: () => dispatch(updatePusherDistinctId()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PusherEmitter);
